import React from "react";
import { makeStyles } from 'tss-react/mui';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// @mui/icons-material
import Search from "@mui/icons-material/Search";
import Email from "@mui/icons-material/Email";
import Face from "@mui/icons-material/Face";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Explore from "@mui/icons-material/Explore";
// core components
import GridContainer from "../../components/Grid/GridContainer.js";
import GridItem from "../../components/Grid/GridItem.js";
import CustomDropdown from "../../components/CustomDropdown/CustomDropdown.js";
import styles from "../../styles/jss/nextjs-material-kit/pages/componentsSections/adviceDynamicSearchStyle.js";

const useStyles = makeStyles()(styles);

export default function SectionNavbars() {
  const { classes } = useStyles();
  return (
    <div className={classes.container}>
      <GridContainer
        className="justify-content-md-center"
        style={{ paddingLeft: 0 }}
      >
        <GridItem xs={12} sm={12} md={12} style={{ paddingLeft: "0px" }}>
          <List className={classes.list} style={{ paddingLeft: "0px" }}>
            <ListItem className={classes.listItem}>
              <CustomDropdown
                navDropdown
                buttonText="Date"
                buttonProps={{
                  className: classes.dropDown,
                }}
                dropdownList={["Engineering", "Catering", "Marketing"]}
              />
            </ListItem>
            <ListItem className={classes.listItem}>
              <CustomDropdown
                navDropdown
                buttonText="Category"
                buttonProps={{
                  className: classes.dropDown,
                }}
                dropdownList={[
                  "Long Term",
                  "Short Term",
                  "Full-time",
                  "Part-time",
                ]}
              />
            </ListItem>
            <ListItem className={classes.listItem}>
              <CustomDropdown
                navDropdown
                buttonText="Sub-category"
                buttonProps={{
                  className: classes.dropDown,
                }}
                dropdownList={[
                  "Long Term",
                  "Short Term",
                  "Full-time",
                  "Part-time",
                ]}
              />
            </ListItem>
          </List>
        </GridItem>
      </GridContainer>
    </div>
  );
}
